<template>
  <span class="status" :class="[small ? 'small' : '', btnType]" :style="customColor">
    <slot>
    </slot>
  </span>
</template>

<script>
import BootstrapColors from "../../enums/BootstrapColors";
export default {
  name: "Pill.vue",
    props: {
      type: {
        validator(value) {
          return Object.values(BootstrapColors).includes(value);
        },
        default() {
          return BootstrapColors.primary
        }
      },
      color: {
        type: String,
        default: null,
        required: false,
      },
      small: {
        default: true,
        type: Boolean,
        required: false,
      }
    },
    computed: {
      btnType() {
        return 'button-' + this.type;
      },
      customColor() {
        return this.color !== null ? {
          color: 'white',
          backgroundColor: this.color,
        } : {};
      }
    },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.status {
  font-weight: 400;
  font-size: $font-size-small;
  text-transform: none;
  letter-spacing: normal;
  border-radius: $border-radius-small;
  padding: 2px $spacing-xxs;
  &.small {
    padding: $spacing-xxs;
    font-weight: bold;
    border-radius: $border-radius-small;
    font-size: 8.5px;
    text-transform: uppercase;
    letter-spacing: .05em;
  }
}
</style>
